import Product from '@/creditflowresearch/domain/Product/Product';
import Segment from '@/creditflowresearch/domain/Segment';
import { ProductType, ProductAbbreviations } from '@/creditflowresearch/domain/Product/types/ProductType';
import { ABS_SEGMENTS } from '@/creditflowresearch/domain/Segment/constants';
import {
  ABS_PRODUCT_ID,
  ABS_ABBREVIATION,
  ABS_TYPE,
} from '@/creditflowresearch/domain/Product/constants';

class AbsProduct extends Product {
  static readonly PRODUCT_ID: string = ABS_PRODUCT_ID;

  static readonly ABBREVIATION: ProductAbbreviations = ABS_ABBREVIATION;

  static readonly TYPE: ProductType = ABS_TYPE;

  getDefaultProductId(accessibleProductIds: string[] = []): string {
    return accessibleProductIds.length > 0 ? this.id : this.id;
  }

  getDefaultForContext(): Product | null {
    return AbsProduct.getDefault();
  }

  getMarketIds(): string[] {
    return [];
  }

  getSegments(): Segment[] {
    return ABS_SEGMENTS.map((type) => Segment.from(type)).filter(
      (segment): segment is Segment => segment !== null,
    );
  }

  static getDefault(): Product | null {
    return Product.from(ABS_PRODUCT_ID);
  }
}

export default AbsProduct;
